import { render, staticRenderFns } from "./NotaFiscalModoTransporte.vue?vue&type=template&id=4b5a36cb&"
import script from "./NotaFiscalModoTransporte.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalModoTransporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports